var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Edit-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(3.000000, 1.500000)",
    stroke: "#000000",
    strokeWidth: 1.33333333
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,1.41421354 L1.33333333,1.41421354 C0.596953667,1.41421354 0,2.01116721 0,2.74754687 L0,12.0808802 C0,12.8172599 0.596953667,13.4142135 1.33333333,13.4142135 L10.6666667,13.4142135 C11.4030463,13.4142135 12,12.8172599 12,12.0808802 L12,7.41421354",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,0.414213541 C11.5522848,-0.138071189 12.4477152,-0.138071179 13,0.414213562 C13.5522847,0.966498304 13.5522847,1.86192879 13,2.41421354 L6.66666667,8.74754687 L4,9.41421354 L4.66666667,6.74754687 L11,0.414213541 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit-2.7901aa142934ec3b8731ba5facf52efd.svg";
export { ForwardRef as ReactComponent };